<template>
  <div class="video-rate">
    <a-card :bordered="false" class="card">
      <div class="head">
        <div>
          <div class="title">{{ view.title }}</div>
          <div class="desc">{{ view.desc }}</div>
        </div>
        <a-button type="primary" icon="reload" :loading="loading" @click="load">刷新</a-button>
      </div>

      <a-spin :spinning="loading">
        <div class="stat" :class="headline.level">
          <div class="label">{{ headline.label }}</div>
          <div class="value">{{ headline.value_text }}<span class="pct">{{ headline.unit }}</span></div>
          <div class="sub">{{ headline.sub }}</div>
        </div>
      </a-spin>

      <a-alert v-if="errorMsg" class="err" type="info" show-icon :message="errorMsg" />
    </a-card>

    <a-card :bordered="false" class="card" style="margin-top:16px">
      <div slot="title">各通道明细</div>
      <a-table
        :columns="tableColumns"
        :dataSource="view.rows"
        :pagination="false"
        :loading="loading"
        size="middle"
        :rowKey="(record, index) => index"
        :locale="{ emptyText: '暂无数据' }"
      />
    </a-card>
  </div>
</template>

<script>
import { VideoRateStats } from "api/videoRate"

export default {
  name: "VideoRate",
  data() {
    return {
      loading: false,
      errorMsg: "",
      view: {
        title: "视频在线率",
        desc: "",
        headline: { label: "", value_text: "0.00", unit: "%", sub: "", level: "normal" },
        columns: [],
        rows: []
      }
    }
  },
  computed: {
    headline() {
      return this.view.headline || {}
    },
    tableColumns() {
      const h = this.$createElement
      return (this.view.columns || []).map(col => ({
        title: col.title,
        dataIndex: col.key,
        width: col.width,
        align: col.align || "left",
        customRender: (text, record) => {
          if (col.type === "mono") {
            return h("span", { class: "mono" }, text)
          }
          if (col.type === "rate") {
            const n = Number(record.rate) || 0
            return h("span", { class: n >= 95 ? "ok" : "normal" }, text)
          }
          if (col.type === "status") {
            return h(
              "a-tag",
              { props: { color: record.online ? "green" : "default" } },
              record.online_text
            )
          }
          return text
        }
      }))
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      this.errorMsg = ""
      VideoRateStats()
        .then(res => {
          if (res.code !== 0) {
            this.errorMsg = res.message || res.msg || "获取统计数据失败"
            return
          }
          const data = res.data || {}
          this.view = {
            title: data.title || "视频在线率",
            desc: data.desc || "",
            headline: data.headline || { label: "", value_text: "0.00", unit: "%", sub: "", level: "normal" },
            columns: data.columns || [],
            rows: data.rows || []
          }
        })
        .catch(err => {
          console.error(err)
          this.errorMsg = "获取统计数据失败，请稍后刷新"
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.video-rate { padding: 16px; }
.card { border-radius: 4px; }
.head { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 16px; }
.title { font-size: 16px; font-weight: 600; color: #262626; }
.desc { margin-top: 4px; font-size: 12px; color: #8c8c8c; }
.stat { border-radius: 4px; background: #fafafa; border: 1px solid #f0f0f0; padding: 24px 16px; text-align: center; }
.stat .label { font-size: 13px; color: #595959; }
.stat .value { margin: 10px 0; font-size: 42px; font-weight: 700; line-height: 1.15; font-variant-numeric: tabular-nums; }
.stat .pct { font-size: 20px; font-weight: 500; margin-left: 2px; }
.stat.ok .value { color: #52c41a; }
.stat.normal .value { color: #1890ff; }
.stat .sub { margin-top: 10px; font-size: 12px; color: #8c8c8c; }
.mono { font-family: Consolas, Menlo, monospace; font-size: 12px; color: #595959; }
.ok { color: #52c41a; }
.normal { color: #1890ff; }
.err { margin-top: 16px; }
</style>
